import { Accordion } from "@app/shared/Accordion"
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import InfoIndicator from "@app/shared/InfoIndicator";

export const HospitalProfileProviders: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedHospital } = providerHubContext;

  return (
    <Accordion title="Institutionally Affiliated Providers" testId="hospital-profile__providers-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-title">Category</dt>
          <dd className="provider-profile__overview-title">Number of Providers</dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Servicing Providers <InfoIndicator className={"informational-indicator"} tooltipWidth="320px" tooltipTitle={<>Total servicing providers are calculated based on access point data per provider.<br /><br />Servicing provider counts may not equal in-network and out-of-network totals as providers may have access points in both categories.</>} /></dt>
          <dd className="provider-profile__overview-value">{selectedHospital.servicingProviders}</dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">In-network Providers</dt>
          <dd className="provider-profile__overview-value">{selectedHospital.inNetworkServicingProviders}</dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Out-of-network Providers</dt>
          <dd className="provider-profile__overview-value">{selectedHospital.outOfNetworkServicingProviders}</dd>
        </div>
      </dl>
    </Accordion>
  )
};
